import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-m heading-2xl mb-6 md:mb-8',
    fields: 'flex flex-col gap-6 pb-8',
    agreements: 'heading-xs flex flex-col gap-4',
    row: 'flex items-center justify-between',
    button: 'mt-8 max-md:w-full md:mt-12'
  }
});
